var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        {
          ref: "createPaymentJournalRef",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c(
            "custom-callout",
            {
              staticClass: "mb-4 custom-callout-invoice",
              attrs: { "border-color": "green", "has-toggle": false }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("icon-view", {
                      attrs: {
                        icon: "fa fa-file-plus",
                        "icon-background": "#fff",
                        "icon-color": "#2DB782",
                        "icon-size": "16px",
                        title: "Crear Nuevo Jornal de Pago"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row ml-2 mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-md-3 col-sm-12 pb-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-secondary-6 font-weight-normal font-14 mb-2"
                      },
                      [_vm._v(" Año Académico: ")]
                    ),
                    _c("validation-provider", {
                      attrs: { mode: "eager", rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("drop-down", {
                                attrs: {
                                  id: "ddlAcademicYear",
                                  clearable: false,
                                  "custom-error-msg": "Campo requerido.",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.academicYears,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.model.academicYear,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "academicYear", $$v)
                                  },
                                  expression: "model.academicYear"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-9 text-right mt-3 pr-5" },
                  [
                    _c(
                      "action-button",
                      {
                        attrs: {
                          id: "btnCancel",
                          i: "fas fa-times-circle",
                          variant:
                            "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCancel()
                          }
                        }
                      },
                      [_vm._v(" Cancelar ")]
                    ),
                    _c(
                      "action-button",
                      {
                        attrs: {
                          id: "btnContinue",
                          i: "fas fa-arrow-circle-right",
                          variant: "success pl-4 pr-4"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onContinue()
                          }
                        }
                      },
                      [_vm._v(" Continuar ")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }